
    <div class="cell-content">
      {{ day }}
    </div>
  